module.exports = __webpack_public_path__ + "static/media/parkering.8d2c85d5.png";